import React from 'react';
import TopBar from '../../Components/TopBar';
import Form, { PhoneNumberValidator, RequiredValidator, TextField, Actions } from '../../Components/Form';
import { useToasts } from '../../Components/Toasts';
import API from '../../Services/API';
import Page from '../../Components/Containers/Page';
import { useParams } from 'react-router-dom';

const Dial = () => {
    const { number: numberFromParams } = useParams();
    const {showSuccess, showError} = useToasts();

    const placeCall = async (data) => {
        await API.post('/telnyx/call', data)
            .then(() => showSuccess('Call starting'))
            .catch((err) => showError(API.parseErrorResponse(err)));
    }

    return <>
        <TopBar left="/admin" title="Dial" />
        <Page>
            <Form data={{numberFromParams}} onSubmit={placeCall}>
                <TextField name="number" label="Number" validators={[RequiredValidator, PhoneNumberValidator]} />
                <Actions submit={{label: 'Dial'}} cancel />
            </Form>
        </Page>
    </>
}

export default Dial;
